import ProjectForm from "@/components/projects/ProjectForm";
import HackatimeConnect from "@/components/projects/HackatimeConnect";
import PageHeading from "@/components/layout/PageHeading";
import Layout from "@/layouts/layout";

import type { HackatimeProject } from "@/interfaces/hackatime_project";
import type { ProjectTag } from "@/interfaces/project_tag";
import type { ShippableEvent } from "@/interfaces/shippable_event";

interface Props {
  hackatime_projects: HackatimeProject[];
  shippable_events: ShippableEvent[];
  travel_grant: boolean;
  projects_count: number;
  tags: ProjectTag[];
}

export default function NewProject({
  hackatime_projects,
  shippable_events,
  travel_grant,
  tags,
}: Props) {
  return (
    <Layout>
      <div className="flex flex-col gap-6">
        <PageHeading eyebrow="Projects" title="New project" />
        <HackatimeConnect compact />
        <ProjectForm
          hackatime_projects={hackatime_projects}
          shippable_events={shippable_events}
          travel_grant={travel_grant}
          tags={tags}
          tutorial={true}
        />
      </div>
    </Layout>
  );
}
